
import React from "react";
import { Calendar } from "lucide-react";

const ScheduleStep = ({ installationData, handleInputChange, errors }) => {
  return (
    <div className="space-y-8">
      <div className="text-center">
        <Calendar className="w-16 h-16 text-emerald-600 mx-auto mb-4" />
        <h2 className="text-2xl font-bold text-gray-900 mb-2">
          Schedule Your Installation
        </h2>
        <p className="text-gray-600">Choose your preferred date and time</p>
      </div>

      {/* Date Selection */}
      <div className="space-y-6">
        <div className="grid md:grid-cols-2 gap-6">
          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-3">
              Preferred Start Date
            </label>
            <input
              type="date"
              value={installationData.preferredDate}
              onChange={(e) => handleInputChange("preferredDate", e.target.value)}
              min={new Date().toISOString().split("T")[0]}
              className={`w-full p-4 border-2 rounded-2xl focus:ring-4 focus:ring-emerald-100 focus:border-emerald-500 transition-all text-lg ${
                errors.preferredDate ? "border-red-300" : "border-gray-200"
              }`}
            />
            {errors.preferredDate && (
              <p className="text-red-500 text-sm mt-1">
                {errors.preferredDate}
              </p>
            )}
          </div>

          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-3">
              Preferred Time
            </label>
            <select
              value={installationData.preferredTime}
              onChange={(e) => handleInputChange("preferredTime", e.target.value)}
              className={`w-full p-4 border-2 rounded-2xl focus:ring-4 focus:ring-emerald-100 focus:border-emerald-500 transition-all text-lg ${
                errors.preferredTime ? "border-red-300" : "border-gray-200"
              }`}
            >
              <option value="">Select time</option>
              <option value="8:00 AM">8:00 AM - Early Morning</option>
              <option value="10:00 AM">10:00 AM - Morning</option>
              <option value="1:00 PM">1:00 PM - Afternoon</option>
              <option value="3:00 PM">3:00 PM - Late Afternoon</option>
            </select>
            {errors.preferredTime && (
              <p className="text-red-500 text-sm mt-1">
                {errors.preferredTime}
              </p>
            )}
          </div>
        </div>

        <div className="grid md:grid-cols-2 gap-6">
          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-3">
              Backup Date (Optional)
            </label>
            <input
              type="date"
              value={installationData.alternateDate}
              onChange={(e) => handleInputChange("alternateDate", e.target.value)}
              min={new Date().toISOString().split("T")[0]}
              className="w-full p-4 border-2 border-gray-200 rounded-2xl focus:ring-4 focus:ring-emerald-100 focus:border-emerald-500 transition-all text-lg"
            />
          </div>

          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-3">
              Backup Time (Optional)
            </label>
            <select
              value={installationData.alternateTime}
              onChange={(e) => handleInputChange("alternateTime", e.target.value)}
              className="w-full p-4 border-2 border-gray-200 rounded-2xl focus:ring-4 focus:ring-emerald-100 focus:border-emerald-500 transition-all text-lg"
            >
              <option value="">Select time</option>
              <option value="8:00 AM">8:00 AM - Early Morning</option>
              <option value="10:00 AM">10:00 AM - Morning</option>
              <option value="1:00 PM">1:00 PM - Afternoon</option>
              <option value="3:00 PM">3:00 PM - Late Afternoon</option>
            </select>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ScheduleStep;
